import { Button } from "antd";
import Blue_Pin from "../../../../../assets/Blue_Pin.svg";
export const QuickFilterFooter = ({
  setQuickFilterChecked,
  setSelectedCount,
  filterTemplates,
  selectedCount,
  setPinFilters,
}) => {
  return (
    <div className="d-flex justify-content-between align-items-baseline">
      <Button
        onClick={() => {
          setQuickFilterChecked({});
          setSelectedCount(0);
        }}
        disabled={!filterTemplates}
        className="btn_Clear"
        style={{ visibility: `${selectedCount > 1 ? "visible" : "hidden"}` }}
      >
        Unselect All
      </Button>
      {selectedCount > 0 ? (
        <p
          className="text_regular font-weight400"
          // style={{ padding: "0.5rem 1rem" }}
        >
          You have selected{" "}
          <span style={{ color: "rgb(94, 214, 109)" }}>{selectedCount}</span>{" "}
          quick filter{selectedCount > 1 ? "s" : ""}
        </p>
      ) : (
        <p className="text_regular font-weight400">
          No quick filter is selected
        </p>
      )}
      <div className="d-flex">
        <Button
          onClick={setPinFilters}
          disabled={!filterTemplates?.length ? true : false}
        >
          <img
            style={{ width: "2.6rem", height: "2rem" }}
            className="pr-2"
            src={Blue_Pin}
            alt="pin-icon"
          />
          <span class="text_regular font-weight500">Pin</span>
        </Button>
      </div>
    </div>
  );
};
